import { useCallback, useState } from "react";

export default function useLocalStorageState<T>(key: string, initialValue: T) {
    const [value, setValue] = useState<T>(() => {
        try {
            const item = window.localStorage.getItem(key);
            if (item !== null) {
                return JSON.parse(item);
            }
        } catch {}

        return initialValue;
    });

    const setStoredValue = useCallback(
        (nextValue: T | ((prev: T) => T)) => {
            setValue((prev) => {
                const valueToStore =
                    typeof nextValue === "function"
                        ? (nextValue as (prevState: T) => T)(prev)
                        : nextValue;

                try {
                    window.localStorage.setItem(
                        key,
                        JSON.stringify(valueToStore)
                    );
                } catch {}

                return valueToStore;
            });
        },
        [key]
    );

    return [value, setStoredValue] as const;
}
